import { Col, Row } from "antd";
import { useEffect } from "react";
import { IoIosArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { extractDate } from "../../config/helpers";

const FeedbackDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const feedback = location?.state?.feedback;
  useEffect(() => {
    if (!feedback) {
      navigate(-1);
    }
    // eslint-disable-next-line
  },[]
)

  return (
    <Row justify="center">
      <Col md={23} xs={22}>
        <div
          className="bg-white rounded-lg sm:py-16 py-8 my-12"
          style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)", padding: "40px 30px" }}
        >
          <div className="flex justify-start mb-8">
            <div className="flex justify-center items-center">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Booking Request
              </h3>
            </div>
          </div>

          <Row justify="start">
            <Col xs={24} sm={24} md={24}>
              <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center" style={{ padding: "40px", width: "100%" }}>
                <Row gutter={[32, 16]} className="w-full">
                  <Col xs={24} sm={12} md={8}>
                    <div className="flex flex-col items-start">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Name
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.firstName} {feedback?.lastName}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Email
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.email}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Phone
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.phone || "-"}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Date Submitted
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {extractDate(feedback?.createdAt)}
                      </p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <div className="flex flex-col items-start">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Pick Up Date
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.pickUpDate ? extractDate(feedback?.pickUpDate) : "-"}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Duration
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.duration || "-"}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Pick Up Location
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.pickUpLocation || "-"}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Drop Off Location
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.dropOffLocation || "-"}
                      </p>
                    </div>
                  </Col>
                  <Col xs={24} sm={12} md={8}>
                    <div className="flex flex-col items-start">
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Vehicle Category
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.vehicleCategory || "-"}
                      </p>
                      <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                        Number of Passengers
                      </h5>
                      <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                        {feedback?.numberOfPassenger || "-"}
                      </p>
                    </div>
                  </Col>
                </Row>
                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                  Message
                </h5>
                <p className="font-euclid text-sm max-sm:text-xs text-[#575757] font-normal mb-6">
                 {feedback?.message}
                </p>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default FeedbackDetail;
